import React, {Component} from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import {Icon} from 'antd';
import './style.css';

export default class CollapsePanel extends Component {

  state = {
    expanded: true
  }

  componentDidMount() {
    const dom = this.refs.collapse;
    const height = dom.offsetHeight;
    const style={
      height: `${height}px`,
    }
    this.setState({
      height: `${height}px`,
      style: style
    })
  }

  handlePanel = () => {

    let style={}
    if (this.state.expanded) {
      style={
        height: '0px',
      }
    } else {
      style={
        height: this.state.height,
      }
    }
    this.setState({
      expanded: !this.state.expanded,
      style: style
    })
  }

  render() {
    const {subjects, title, subjectIds} = this.props;
    return (
      <div>
        <div className="ant-collapse">
          <div className="ant-collapse-item">
            <div className="ant-collapse-header collapse-header-header" role="tab" onClick={this.handlePanel}>
              <div className="collapse-header-title">{title}</div>
              <Icon type="bars" className="collapse-header-bars" />
            </div>
            <div className="ant-collapse-content transition-all"
            ref='collapse'
            style={this.state.style}
             role="tabpanel">
              <div className="ant-collapse-content-box">
                {_.map(subjectIds, (subjectId) => {
                  const subject = subjects[subjectId]
                  return (
                    <div className="collapse-content-title">{subject.name}</div>
                  )
                })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/search/components/CollapsePanel.js
 **/